const ENV = {
  ARTICLE_LIST: [
    {
      name: "决战港股",
      value: "hkstocks"
    },
    {
      name: "汇说",
      value: "freetalks"
    },
    {
      name: "汇路演",
      value: "roadshow"
    },
    {
      name: "榜单",
      value: "rank"
    },
    {
      name: "活动报名",
      value: "enroll"
    },
    {
      name: "高屋建瓴",
      value: "realty"
    }
  ]
};

const install = Vue => {
  if (install.installed) return;
  install.installed = true;

  Object.defineProperties(Vue.prototype, {
    $env: {
      get() {
        return ENV;
      }
    }
  });
};

export default {
  install
};



// WEBPACK FOOTER //
// ./src/env.js